import { Directive, HostListener, output } from '@angular/core';

@Directive({
  selector: '[appFocusable]',
})
export class AppFocusableDirective {

  public readonly onFocusChange = output<boolean>();

  @HostListener('focus')
  public onFocus(): void {
    this.onFocusChange.emit(true);
  }

  @HostListener('blur')
  public onBlur(): void {
    this.onFocusChange.emit(false);
  }
}
